// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f61d54b5","977":"4d03a34f"}[chunkId] + ".chunk.js";
};